import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/software/compare/CompareClient.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
